// source: acompanha/operational_costs/v1/operational_costs.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js');
goog.object.extend(proto, acompanha_common_v1_common_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.acompanha.operational_costs.v1.CreateOperationalCostRequest', null, global);
goog.exportSymbol('proto.acompanha.operational_costs.v1.CreateOperationalCostResponse', null, global);
goog.exportSymbol('proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest', null, global);
goog.exportSymbol('proto.acompanha.operational_costs.v1.GetOperationalCostRequest', null, global);
goog.exportSymbol('proto.acompanha.operational_costs.v1.GetOperationalCostResponse', null, global);
goog.exportSymbol('proto.acompanha.operational_costs.v1.ListOperationalCostsRequest', null, global);
goog.exportSymbol('proto.acompanha.operational_costs.v1.ListOperationalCostsResponse', null, global);
goog.exportSymbol('proto.acompanha.operational_costs.v1.OperationalCost', null, global);
goog.exportSymbol('proto.acompanha.operational_costs.v1.OperationalCostsStats', null, global);
goog.exportSymbol('proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest', null, global);
goog.exportSymbol('proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse', null, global);
goog.exportSymbol('proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest', null, global);
goog.exportSymbol('proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.operational_costs.v1.OperationalCost = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.operational_costs.v1.OperationalCost, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.operational_costs.v1.OperationalCost.displayName = 'proto.acompanha.operational_costs.v1.OperationalCost';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.operational_costs.v1.OperationalCostsStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.operational_costs.v1.OperationalCostsStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.operational_costs.v1.OperationalCostsStats.displayName = 'proto.acompanha.operational_costs.v1.OperationalCostsStats';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.operational_costs.v1.ListOperationalCostsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.operational_costs.v1.ListOperationalCostsRequest.displayName = 'proto.acompanha.operational_costs.v1.ListOperationalCostsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.operational_costs.v1.ListOperationalCostsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.displayName = 'proto.acompanha.operational_costs.v1.ListOperationalCostsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.operational_costs.v1.GetOperationalCostRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.operational_costs.v1.GetOperationalCostRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.operational_costs.v1.GetOperationalCostRequest.displayName = 'proto.acompanha.operational_costs.v1.GetOperationalCostRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.operational_costs.v1.GetOperationalCostResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.operational_costs.v1.GetOperationalCostResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.operational_costs.v1.GetOperationalCostResponse.displayName = 'proto.acompanha.operational_costs.v1.GetOperationalCostResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.operational_costs.v1.CreateOperationalCostRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.operational_costs.v1.CreateOperationalCostRequest.displayName = 'proto.acompanha.operational_costs.v1.CreateOperationalCostRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.operational_costs.v1.CreateOperationalCostResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.operational_costs.v1.CreateOperationalCostResponse.displayName = 'proto.acompanha.operational_costs.v1.CreateOperationalCostResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.displayName = 'proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse.displayName = 'proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest.displayName = 'proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse.displayName = 'proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest.displayName = 'proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.operational_costs.v1.OperationalCost.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.operational_costs.v1.OperationalCost} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.OperationalCost.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
uuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
name: jspb.Message.getFieldWithDefault(msg, 3, ""),
category: jspb.Message.getFieldWithDefault(msg, 4, ""),
amountCents: jspb.Message.getFieldWithDefault(msg, 5, 0),
recurrence: jspb.Message.getFieldWithDefault(msg, 6, ""),
notes: jspb.Message.getFieldWithDefault(msg, 7, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
frequency: jspb.Message.getFieldWithDefault(msg, 10, ""),
monthlyAmountCents: jspb.Message.getFieldWithDefault(msg, 11, 0),
archivedAt: (f = msg.getArchivedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.operational_costs.v1.OperationalCost}
 */
proto.acompanha.operational_costs.v1.OperationalCost.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.operational_costs.v1.OperationalCost;
  return proto.acompanha.operational_costs.v1.OperationalCost.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.operational_costs.v1.OperationalCost} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.operational_costs.v1.OperationalCost}
 */
proto.acompanha.operational_costs.v1.OperationalCost.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountCents(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecurrence(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrequency(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMonthlyAmountCents(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setArchivedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.operational_costs.v1.OperationalCost.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.operational_costs.v1.OperationalCost} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.OperationalCost.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getRecurrence();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFrequency();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getMonthlyAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getArchivedAt();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.OperationalCost} returns this
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string uuid = 2;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.OperationalCost} returns this
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.OperationalCost} returns this
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string category = 4;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.OperationalCost} returns this
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 amount_cents = 5;
 * @return {number}
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.getAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.operational_costs.v1.OperationalCost} returns this
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.setAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string recurrence = 6;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.getRecurrence = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.OperationalCost} returns this
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.setRecurrence = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string notes = 7;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.OperationalCost} returns this
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.operational_costs.v1.OperationalCost} returns this
*/
proto.acompanha.operational_costs.v1.OperationalCost.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.operational_costs.v1.OperationalCost} returns this
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.operational_costs.v1.OperationalCost} returns this
*/
proto.acompanha.operational_costs.v1.OperationalCost.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.operational_costs.v1.OperationalCost} returns this
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string frequency = 10;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.getFrequency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.OperationalCost} returns this
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.setFrequency = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int64 monthly_amount_cents = 11;
 * @return {number}
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.getMonthlyAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.operational_costs.v1.OperationalCost} returns this
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.setMonthlyAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional google.protobuf.Timestamp archived_at = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.getArchivedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.operational_costs.v1.OperationalCost} returns this
*/
proto.acompanha.operational_costs.v1.OperationalCost.prototype.setArchivedAt = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.operational_costs.v1.OperationalCost} returns this
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.clearArchivedAt = function() {
  return this.setArchivedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.operational_costs.v1.OperationalCost.prototype.hasArchivedAt = function() {
  return jspb.Message.getField(this, 12) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.operational_costs.v1.OperationalCostsStats.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.operational_costs.v1.OperationalCostsStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.operational_costs.v1.OperationalCostsStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.OperationalCostsStats.toObject = function(includeInstance, msg) {
  var f, obj = {
totalItems: jspb.Message.getFieldWithDefault(msg, 1, 0),
recurringTotalCents: jspb.Message.getFieldWithDefault(msg, 2, 0),
oneTimeTotalCents: jspb.Message.getFieldWithDefault(msg, 3, 0),
monthTotalCents: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.operational_costs.v1.OperationalCostsStats}
 */
proto.acompanha.operational_costs.v1.OperationalCostsStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.operational_costs.v1.OperationalCostsStats;
  return proto.acompanha.operational_costs.v1.OperationalCostsStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.operational_costs.v1.OperationalCostsStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.operational_costs.v1.OperationalCostsStats}
 */
proto.acompanha.operational_costs.v1.OperationalCostsStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalItems(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRecurringTotalCents(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOneTimeTotalCents(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMonthTotalCents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.operational_costs.v1.OperationalCostsStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.operational_costs.v1.OperationalCostsStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.operational_costs.v1.OperationalCostsStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.OperationalCostsStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalItems();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getRecurringTotalCents();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getOneTimeTotalCents();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getMonthTotalCents();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional int32 total_items = 1;
 * @return {number}
 */
proto.acompanha.operational_costs.v1.OperationalCostsStats.prototype.getTotalItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.operational_costs.v1.OperationalCostsStats} returns this
 */
proto.acompanha.operational_costs.v1.OperationalCostsStats.prototype.setTotalItems = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 recurring_total_cents = 2;
 * @return {number}
 */
proto.acompanha.operational_costs.v1.OperationalCostsStats.prototype.getRecurringTotalCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.operational_costs.v1.OperationalCostsStats} returns this
 */
proto.acompanha.operational_costs.v1.OperationalCostsStats.prototype.setRecurringTotalCents = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 one_time_total_cents = 3;
 * @return {number}
 */
proto.acompanha.operational_costs.v1.OperationalCostsStats.prototype.getOneTimeTotalCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.operational_costs.v1.OperationalCostsStats} returns this
 */
proto.acompanha.operational_costs.v1.OperationalCostsStats.prototype.setOneTimeTotalCents = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 month_total_cents = 4;
 * @return {number}
 */
proto.acompanha.operational_costs.v1.OperationalCostsStats.prototype.getMonthTotalCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.operational_costs.v1.OperationalCostsStats} returns this
 */
proto.acompanha.operational_costs.v1.OperationalCostsStats.prototype.setMonthTotalCents = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.operational_costs.v1.ListOperationalCostsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.operational_costs.v1.ListOperationalCostsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && acompanha_common_v1_common_pb.PaginationRequest.toObject(includeInstance, f),
recurrence: jspb.Message.getFieldWithDefault(msg, 2, ""),
category: jspb.Message.getFieldWithDefault(msg, 3, ""),
archived: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.operational_costs.v1.ListOperationalCostsRequest}
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.operational_costs.v1.ListOperationalCostsRequest;
  return proto.acompanha.operational_costs.v1.ListOperationalCostsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.operational_costs.v1.ListOperationalCostsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.operational_costs.v1.ListOperationalCostsRequest}
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new acompanha_common_v1_common_pb.PaginationRequest;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecurrence(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setArchived(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.operational_costs.v1.ListOperationalCostsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.operational_costs.v1.ListOperationalCostsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      acompanha_common_v1_common_pb.PaginationRequest.serializeBinaryToWriter
    );
  }
  f = message.getRecurrence();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getArchived();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional acompanha.common.v1.PaginationRequest pagination = 1;
 * @return {?proto.acompanha.common.v1.PaginationRequest}
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsRequest.prototype.getPagination = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationRequest} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationRequest, 1));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationRequest|undefined} value
 * @return {!proto.acompanha.operational_costs.v1.ListOperationalCostsRequest} returns this
*/
proto.acompanha.operational_costs.v1.ListOperationalCostsRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.operational_costs.v1.ListOperationalCostsRequest} returns this
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string recurrence = 2;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsRequest.prototype.getRecurrence = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.ListOperationalCostsRequest} returns this
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsRequest.prototype.setRecurrence = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string category = 3;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsRequest.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.ListOperationalCostsRequest} returns this
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsRequest.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string archived = 4;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsRequest.prototype.getArchived = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.ListOperationalCostsRequest} returns this
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsRequest.prototype.setArchived = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.operational_costs.v1.ListOperationalCostsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.acompanha.operational_costs.v1.OperationalCost.toObject, includeInstance),
meta: (f = msg.getMeta()) && acompanha_common_v1_common_pb.PaginationMeta.toObject(includeInstance, f),
stats: (f = msg.getStats()) && proto.acompanha.operational_costs.v1.OperationalCostsStats.toObject(includeInstance, f),
archivedTotal: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.operational_costs.v1.ListOperationalCostsResponse}
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.operational_costs.v1.ListOperationalCostsResponse;
  return proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.operational_costs.v1.ListOperationalCostsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.operational_costs.v1.ListOperationalCostsResponse}
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.operational_costs.v1.OperationalCost;
      reader.readMessage(value,proto.acompanha.operational_costs.v1.OperationalCost.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.PaginationMeta;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationMeta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = new proto.acompanha.operational_costs.v1.OperationalCostsStats;
      reader.readMessage(value,proto.acompanha.operational_costs.v1.OperationalCostsStats.deserializeBinaryFromReader);
      msg.setStats(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setArchivedTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.operational_costs.v1.ListOperationalCostsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.operational_costs.v1.OperationalCost.serializeBinaryToWriter
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_common_v1_common_pb.PaginationMeta.serializeBinaryToWriter
    );
  }
  f = message.getStats();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.acompanha.operational_costs.v1.OperationalCostsStats.serializeBinaryToWriter
    );
  }
  f = message.getArchivedTotal();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * repeated OperationalCost items = 1;
 * @return {!Array<!proto.acompanha.operational_costs.v1.OperationalCost>}
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.acompanha.operational_costs.v1.OperationalCost>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.operational_costs.v1.OperationalCost, 1));
};


/**
 * @param {!Array<!proto.acompanha.operational_costs.v1.OperationalCost>} value
 * @return {!proto.acompanha.operational_costs.v1.ListOperationalCostsResponse} returns this
*/
proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.operational_costs.v1.OperationalCost=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.operational_costs.v1.OperationalCost}
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.operational_costs.v1.OperationalCost, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.operational_costs.v1.ListOperationalCostsResponse} returns this
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional acompanha.common.v1.PaginationMeta meta = 2;
 * @return {?proto.acompanha.common.v1.PaginationMeta}
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.prototype.getMeta = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationMeta} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationMeta, 2));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationMeta|undefined} value
 * @return {!proto.acompanha.operational_costs.v1.ListOperationalCostsResponse} returns this
*/
proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.operational_costs.v1.ListOperationalCostsResponse} returns this
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional OperationalCostsStats stats = 3;
 * @return {?proto.acompanha.operational_costs.v1.OperationalCostsStats}
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.prototype.getStats = function() {
  return /** @type{?proto.acompanha.operational_costs.v1.OperationalCostsStats} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.operational_costs.v1.OperationalCostsStats, 3));
};


/**
 * @param {?proto.acompanha.operational_costs.v1.OperationalCostsStats|undefined} value
 * @return {!proto.acompanha.operational_costs.v1.ListOperationalCostsResponse} returns this
*/
proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.prototype.setStats = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.operational_costs.v1.ListOperationalCostsResponse} returns this
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.prototype.clearStats = function() {
  return this.setStats(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.prototype.hasStats = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 archived_total = 4;
 * @return {number}
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.prototype.getArchivedTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.operational_costs.v1.ListOperationalCostsResponse} returns this
 */
proto.acompanha.operational_costs.v1.ListOperationalCostsResponse.prototype.setArchivedTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.operational_costs.v1.GetOperationalCostRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.operational_costs.v1.GetOperationalCostRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.operational_costs.v1.GetOperationalCostRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.GetOperationalCostRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.operational_costs.v1.GetOperationalCostRequest}
 */
proto.acompanha.operational_costs.v1.GetOperationalCostRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.operational_costs.v1.GetOperationalCostRequest;
  return proto.acompanha.operational_costs.v1.GetOperationalCostRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.operational_costs.v1.GetOperationalCostRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.operational_costs.v1.GetOperationalCostRequest}
 */
proto.acompanha.operational_costs.v1.GetOperationalCostRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.operational_costs.v1.GetOperationalCostRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.operational_costs.v1.GetOperationalCostRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.operational_costs.v1.GetOperationalCostRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.GetOperationalCostRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.GetOperationalCostRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.GetOperationalCostRequest} returns this
 */
proto.acompanha.operational_costs.v1.GetOperationalCostRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.operational_costs.v1.GetOperationalCostResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.operational_costs.v1.GetOperationalCostResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.operational_costs.v1.GetOperationalCostResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.GetOperationalCostResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.operational_costs.v1.OperationalCost.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.operational_costs.v1.GetOperationalCostResponse}
 */
proto.acompanha.operational_costs.v1.GetOperationalCostResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.operational_costs.v1.GetOperationalCostResponse;
  return proto.acompanha.operational_costs.v1.GetOperationalCostResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.operational_costs.v1.GetOperationalCostResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.operational_costs.v1.GetOperationalCostResponse}
 */
proto.acompanha.operational_costs.v1.GetOperationalCostResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.operational_costs.v1.OperationalCost;
      reader.readMessage(value,proto.acompanha.operational_costs.v1.OperationalCost.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.operational_costs.v1.GetOperationalCostResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.operational_costs.v1.GetOperationalCostResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.operational_costs.v1.GetOperationalCostResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.GetOperationalCostResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.operational_costs.v1.OperationalCost.serializeBinaryToWriter
    );
  }
};


/**
 * optional OperationalCost data = 1;
 * @return {?proto.acompanha.operational_costs.v1.OperationalCost}
 */
proto.acompanha.operational_costs.v1.GetOperationalCostResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.operational_costs.v1.OperationalCost} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.operational_costs.v1.OperationalCost, 1));
};


/**
 * @param {?proto.acompanha.operational_costs.v1.OperationalCost|undefined} value
 * @return {!proto.acompanha.operational_costs.v1.GetOperationalCostResponse} returns this
*/
proto.acompanha.operational_costs.v1.GetOperationalCostResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.operational_costs.v1.GetOperationalCostResponse} returns this
 */
proto.acompanha.operational_costs.v1.GetOperationalCostResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.operational_costs.v1.GetOperationalCostResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.operational_costs.v1.CreateOperationalCostRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.operational_costs.v1.CreateOperationalCostRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
category: jspb.Message.getFieldWithDefault(msg, 2, ""),
amountCents: jspb.Message.getFieldWithDefault(msg, 3, 0),
recurrence: jspb.Message.getFieldWithDefault(msg, 4, ""),
notes: jspb.Message.getFieldWithDefault(msg, 5, ""),
frequency: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.operational_costs.v1.CreateOperationalCostRequest}
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.operational_costs.v1.CreateOperationalCostRequest;
  return proto.acompanha.operational_costs.v1.CreateOperationalCostRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.operational_costs.v1.CreateOperationalCostRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.operational_costs.v1.CreateOperationalCostRequest}
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountCents(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecurrence(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrequency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.operational_costs.v1.CreateOperationalCostRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.operational_costs.v1.CreateOperationalCostRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getRecurrence();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFrequency();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.CreateOperationalCostRequest} returns this
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string category = 2;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostRequest.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.CreateOperationalCostRequest} returns this
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostRequest.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 amount_cents = 3;
 * @return {number}
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostRequest.prototype.getAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.operational_costs.v1.CreateOperationalCostRequest} returns this
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostRequest.prototype.setAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string recurrence = 4;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostRequest.prototype.getRecurrence = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.CreateOperationalCostRequest} returns this
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostRequest.prototype.setRecurrence = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string notes = 5;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.CreateOperationalCostRequest} returns this
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostRequest.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string frequency = 6;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostRequest.prototype.getFrequency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.CreateOperationalCostRequest} returns this
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostRequest.prototype.setFrequency = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.operational_costs.v1.CreateOperationalCostResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.operational_costs.v1.CreateOperationalCostResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.operational_costs.v1.OperationalCost.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.operational_costs.v1.CreateOperationalCostResponse}
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.operational_costs.v1.CreateOperationalCostResponse;
  return proto.acompanha.operational_costs.v1.CreateOperationalCostResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.operational_costs.v1.CreateOperationalCostResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.operational_costs.v1.CreateOperationalCostResponse}
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.operational_costs.v1.OperationalCost;
      reader.readMessage(value,proto.acompanha.operational_costs.v1.OperationalCost.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.operational_costs.v1.CreateOperationalCostResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.operational_costs.v1.CreateOperationalCostResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.operational_costs.v1.OperationalCost.serializeBinaryToWriter
    );
  }
};


/**
 * optional OperationalCost data = 1;
 * @return {?proto.acompanha.operational_costs.v1.OperationalCost}
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.operational_costs.v1.OperationalCost} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.operational_costs.v1.OperationalCost, 1));
};


/**
 * @param {?proto.acompanha.operational_costs.v1.OperationalCost|undefined} value
 * @return {!proto.acompanha.operational_costs.v1.CreateOperationalCostResponse} returns this
*/
proto.acompanha.operational_costs.v1.CreateOperationalCostResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.operational_costs.v1.CreateOperationalCostResponse} returns this
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.operational_costs.v1.CreateOperationalCostResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
category: jspb.Message.getFieldWithDefault(msg, 3, ""),
amountCents: jspb.Message.getFieldWithDefault(msg, 4, 0),
recurrence: jspb.Message.getFieldWithDefault(msg, 5, ""),
notes: jspb.Message.getFieldWithDefault(msg, 6, ""),
frequency: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest}
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest;
  return proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest}
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountCents(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecurrence(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrequency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getRecurrence();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFrequency();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest} returns this
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest} returns this
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string category = 3;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest} returns this
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 amount_cents = 4;
 * @return {number}
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.prototype.getAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest} returns this
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.prototype.setAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string recurrence = 5;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.prototype.getRecurrence = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest} returns this
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.prototype.setRecurrence = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string notes = 6;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest} returns this
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string frequency = 7;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.prototype.getFrequency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest} returns this
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostRequest.prototype.setFrequency = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.operational_costs.v1.OperationalCost.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse}
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse;
  return proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse}
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.operational_costs.v1.OperationalCost;
      reader.readMessage(value,proto.acompanha.operational_costs.v1.OperationalCost.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.operational_costs.v1.OperationalCost.serializeBinaryToWriter
    );
  }
};


/**
 * optional OperationalCost data = 1;
 * @return {?proto.acompanha.operational_costs.v1.OperationalCost}
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.operational_costs.v1.OperationalCost} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.operational_costs.v1.OperationalCost, 1));
};


/**
 * @param {?proto.acompanha.operational_costs.v1.OperationalCost|undefined} value
 * @return {!proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse} returns this
*/
proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse} returns this
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.operational_costs.v1.UpdateOperationalCostResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
archived: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest}
 */
proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest;
  return proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest}
 */
proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setArchived(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getArchived();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest} returns this
 */
proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool archived = 2;
 * @return {boolean}
 */
proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest.prototype.getArchived = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest} returns this
 */
proto.acompanha.operational_costs.v1.SetOperationalCostArchivedRequest.prototype.setArchived = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.operational_costs.v1.OperationalCost.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse}
 */
proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse;
  return proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse}
 */
proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.operational_costs.v1.OperationalCost;
      reader.readMessage(value,proto.acompanha.operational_costs.v1.OperationalCost.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.operational_costs.v1.OperationalCost.serializeBinaryToWriter
    );
  }
};


/**
 * optional OperationalCost data = 1;
 * @return {?proto.acompanha.operational_costs.v1.OperationalCost}
 */
proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.operational_costs.v1.OperationalCost} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.operational_costs.v1.OperationalCost, 1));
};


/**
 * @param {?proto.acompanha.operational_costs.v1.OperationalCost|undefined} value
 * @return {!proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse} returns this
*/
proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse} returns this
 */
proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.operational_costs.v1.SetOperationalCostArchivedResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest}
 */
proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest;
  return proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest}
 */
proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest} returns this
 */
proto.acompanha.operational_costs.v1.DeleteOperationalCostRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.acompanha.operational_costs.v1);
